import CloseIcon from "@mui/icons-material/Close";
import {
  Badge,
  Box,
  Drawer,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAlarmList } from "../../../application/actions/uiActions";
import { getAlarms } from "../../../application/selectors/ui";
import { ReactComponent as NotificationIcon } from "../../assets/icons/notification.svg";
import LoadingWrapper from "../shared/loading";
import AlarmItem from "./AlarmItem";

const AlarmDrawer = () => {
  const dispatch = useDispatch();

  const { loading, data: alarmList } = useSelector(getAlarms);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const onGetAlarmList = debounce(() => {
    dispatch(fetchAlarmList());
  }, 500);

  useEffect(() => {
    if (!isOpenDrawer) {
      onGetAlarmList();
    }
  }, [isOpenDrawer]);

  const onOpenDrawer = () => {
    setIsOpenDrawer(true);
  };

  const onCloseDrawer = () => {
    setIsOpenDrawer(false);
  };

  return (
    <>
      <IconButton aria-label="alarms" onClick={onOpenDrawer}>
        <Badge
          badgeContent={
            alarmList.length
              ? alarmList.filter((x) => x.alarmStatus === "NotSeen").length
              : 0
          }
          color="primary"
          // variant="dot"
          invisible={false}
        >
          <NotificationIcon />
        </Badge>
      </IconButton>

      <Drawer
        anchor={"right"}
        open={isOpenDrawer}
        onClose={onCloseDrawer}
        ModalProps={{
          keepMounted: false,
          sx: { zIndex: 2000000 },
        }}
        PaperProps={{
          className: "drawer-paper-wrapper",
        }}
      >
        <Box className="header-wrapper">
          <Typography variant="h6" fontWeight={800}>
            پیام ها
          </Typography>

          <IconButton
            size="small"
            onClick={onCloseDrawer}
            sx={{
              display: {
                xs: "inline-flex",
                lg: "none",
              },
            }}
          >
            <CloseIcon className="close-icon" />
          </IconButton>
        </Box>

        <Box className="content-wrapper">
          {loading || alarmList.length === 0 ? (
            <Box
              sx={{
                minHeight: "50vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {loading ? (
                <LoadingWrapper />
              ) : (
                <Typography variant="body2" fontWeight={600}>
                  اطلاعاتی یافت نشد
                </Typography>
              )}
            </Box>
          ) : (
            <Grid container>
              {alarmList.map((alarm) => (
                <AlarmItem alarm={alarm} key={alarm.id} />
              ))}
            </Grid>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default AlarmDrawer;
